<ng-content select="app-grid-column" />
